import gql from "graphql-tag";
import {responseField} from "../../../../store/base.graphql";


export interface GroupedPermission {
  id?: string;
  uniqueId?: string;
  groupName?: string;
  groupDescription?: string;
  groupPermissions?: {
    id?: string;
    uniqueId?: string;
    permissionName?: string;
    permissionCode?: string;
    permissionCreateddate?: string;
    isGlobal?: boolean;
  }[]
}


export const permissionFields = `
id
uniqueId
permissionName
permissionCode
isGlobal
permissionCreateddate
`

export const groupedPermissionsFields = `
id
uniqueId
groupName
groupDescription
groupPermissions {
     ${permissionFields}
}
`

export const GET_ALL_SYSTEM_PERMISSIONS = gql`
query getAllSystemPermissions($filtering: UserPermissionFilterInput) {
  getAllSystemPermissions(filtering: $filtering) {
    response {
      ${responseField}
    }
    data {
      ${groupedPermissionsFields}
    }
  }
}
`
